export default "__VITE_ASSET__w9Xno4sY__"